import axios from 'axios';

import { useGlobalErrorsStore } from '@/shared/hooks/useGlobalErrorsStore';
import { GLOBAL_ERROR_TYPE } from '@/shared/types/GlobalError';

import {
  BAD_REQUEST_STATUS_CODE,
  PAYMENT_REQUIRED_STATUS_CODE,
} from './errors';

export const addRequestInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status as number | undefined;
      const { setGlobalError } = useGlobalErrorsStore.getState();

      if (
        status === PAYMENT_REQUIRED_STATUS_CODE &&
        !error.response?.data?.detail?.endsWith('credits available.')
      ) {
        setGlobalError({ errorType: GLOBAL_ERROR_TYPE.PaymentRequired });
      }

      if (status === BAD_REQUEST_STATUS_CODE && error.response?.data?.detail === 'Inactive user') {
        setGlobalError({ errorType: GLOBAL_ERROR_TYPE.InactiveUser });
      }

      return Promise.reject(error);
    },
  );
};
